﻿/**
 * Kevin's scroll animation attempt
 */
angular.module('fliptoWeb')
    .factory('$waypoint', ['$window', $window => options => new $window.Waypoint(options)])
    .directive('ftPositionalClass', [
        '$waypoint', $waypoint => {
            return {
                restrict: 'A',
                link($scope, $element, $attrs) {
                    var classToChange = $attrs.ftPositionalClass || 'animate-now';
                    var re = new RegExp("(?:^|\\s)" + classToChange + "(?!\\S)");
                    var offsets = [];
                    if ($attrs.ftPositionalClassOffset) {
                        offsets = $attrs.ftPositionalClassOffset.replace(/\s+/g, '').split(',');
                    } else {
                        offsets = [0];
                    }
                    for (var i = 0; i < offsets.length; i++) {
                        $waypoint({
                            handler() {
                                if ($attrs.ftPositionalClassFunction) {
                                    $scope.$eval($attrs.ftPositionalClassFunction);
                                } else if ($attrs.ftPositionalClassRemove) {
                                    this.element.className = this.element.className.replace(re, '');
                                } else {
                                    this.element.className += (" " + classToChange);
                                }

                                // Destroy it if this is only supposed to fire once
                                if (!$attrs.ftPositionalClassMulti) {
                                    this.destroy();
                                }
                            },
                            element: $element[0],
                            continuous: true,
                            offset: offsets[i]
                        });
                    }
                   
                }
            };
        }
    ]);
